import { ThemeProvider } from "@material-ui/core";
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Switch } from 'react-router-dom';
import { PersistGate } from "redux-persist/integration/react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import CssBaseline from "./components/commons/CssBaseLine";
import { persistor, store } from "./redux/store";
import Routes from "./routes/Routes";
import theme from "./styles/theme";

function App() {

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<BrowserRouter>
						<Switch>
							<Routes />
						</Switch>
					</BrowserRouter>
				</PersistGate>
			</Provider>
		</ThemeProvider>
	);
}

export default App;
